import React, { useState } from 'react';
import { Page } from 'react-pdf';
import { Box, CircularProgress } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  spinner: {
    color: 'var(--document-content-loader-color)',
  },
}));

interface Props {
  className: string;
  onRenderSuccess?: () => void;
  pageNumber: number;
  scale: number;
}

const PDFPage: React.FC<Props> = (props: Props) => {
  const classes = useStyles();

  const { className, onRenderSuccess, pageNumber, scale } = props;

  const [showSpinner, setShowSpinner] = useState(false);

  // We don't use Page.loading to have more control over the
  // loading (with spinner) and loaded (without spinner) states
  return (
    <Box className={className}>
      <Page
        loading={<></>}
        // callback when page is starting to render
        onLoadSuccess={() => {
          setShowSpinner(true);
        }}
        // callback when the render is ready
        onRenderSuccess={() => {
          setShowSpinner(false);
          if (onRenderSuccess) onRenderSuccess();
        }}
        pageNumber={pageNumber}
        scale={scale}
      />
      {showSpinner && (
        <Box position="absolute" top="50%" right="50%">
          <CircularProgress
            classes={{ root: classes.spinner }}
            color="secondary"
            size={24}
          />
        </Box>
      )}
    </Box>
  );
};

export default PDFPage;
